import Vue from 'vue'
import App from './App.vue'
import Registration from './components/Registration.vue'
import PrivacyPolicy from "@/components/PrivacyPolicy.vue";



import NonMobile from './components/NonMobile.vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueRouter from 'vue-router';
import vuetify from './plugins/vuetify'
import supabase from "./lib/supabaseClient"
import {store} from "@/store";
import PasswordReset from "@/components/PasswordReset.vue";

Vue.use(VueRouter);

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
    libraries: 'places', // Add any additional libraries you need
    options: {clickableIcons: false}
  },
});

async function checkAuthentication() {
  const { data: { session } } = await supabase.auth.getSession();
/*
  let user = (await supabase.auth.getUser()).data.user
*/
  return !!session?.user
}

window.handleGoogleOneTap = async (response) => {
  // Handle the Google One-Tap Sign-In response
  // console.log('Encoded JWT ID token: ' + response.credential);
  // Now authenticate with Supabase using the Google token
  try {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        id_token: response.credential,
      },
    });
    if (error) throw error;
    if (data) {
      await this.$router.push('/');
    }
  } catch (error) {
    console.error('Error during Supabase auth:', error);
  }
}

// Mobile Detection Function
function isMobileDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
  return isMobile;
}

// Set initial mobile state
Vue.prototype.$isMobile = isMobileDevice();


const routes = [
  // Define your routes here
  { path: '/nonmobile/', component: NonMobile, },
  { path: '/privacy/', component: PrivacyPolicy, },
  { path: '/registration/', component: Registration, },
  { path: '/', component: App, beforeEnter: async (to, from, next) => {
      let isAuth = await checkAuthentication()
      if (isAuth) {
        next();
      } else {
        next('/registration');
      }
    },
  },
  { path: '/reset/', component: PasswordReset, beforeEnter: async (to, from, next) => {
      let isAuth = await checkAuthentication()
      if (isAuth) {
        next();
      } else {
        next('/registration');
      }
    },
  },
]

const router = new VueRouter({
  routes,
  mode: 'history',
});

router.beforeEach((to, from, next) => {
  if (to.path === '/privacy') {
    console.log('Privacy');
    next();
  } else if (!Vue.prototype.$isMobile && (to.path === '/' || to.path === '/registration')) {
    console.log('Not mobile');
    // Redirect to the NonMobileComponent
    next('/nonmobile');
  } else {
    next();
  }
});

new Vue({
  router,
  vuetify,
  store: store,

  render: h => h('router-view')
  // render: function (createElement) {
  //   return createElement('router-view');
  // }
}).$mount('#app')
